import React, { useState } from 'react';
import { Modal, Button, Checkbox } from 'antd';
import { useFormik } from 'formik';
import * as yup from 'yup';
import './index.scss';
import { fetch } from '../../../Utilitys/ApiRequest';
import { useDispatch } from 'react-redux';
import { requestLoginToken } from '../../../Actions/Authentication';

const DataPrivacyModal = ({ visible, onCancel }) => {
   const dispatch = useDispatch();
   const [loading, setLoading] = useState(false);

   const formik = useFormik({
      initialValues: {
         personalization: undefined,
         improvement: undefined
      },
      validationSchema: yup.object().shape({
         personalization: yup.boolean().required('กรุณาเลือกความยินยอม'),
         improvement: yup.boolean().required('กรุณาเลือกความยินยอม')
      }),
      onSubmit: async (values) => {
         try {
            setLoading(true);
            const response = await fetch('post', 'members/consents/privacy', {
               serviceDevelopment: values.improvement,
               personalization: values.personalization
            });

            if (response) {
               dispatch(requestLoginToken(response));
               onCancel();
            }
         } catch (error) {
            console.log(error);
         } finally {
            setLoading(false);
         }
      }
   });

   const modalConfig = {
      visible: visible,
      width: 700,
      footer: null,
      onCancel: onCancel,
      className: 'data-privacy-modal',
      style: { top: 16 }
   };
   return (
      <Modal {...modalConfig}>
         <form onSubmit={formik.handleSubmit}>
            <h1>ความเป็นส่วนตัวของข้อมูล</h1>
            <div className='content-box'>
               <div>
                  <h3>ความยินยอมในการมอบประสบการณ์เฉพาะบุคคล (Personalization)</h3>
                  <p>เว็บไซต์ขอเก็บข้อมูลการใช้งานของคุณเพื่อวิเคราะห์และแสดงเนื้อหาหรือสินค้าที่ ตรงกับความสนใจ</p>
               </div>
               <div className='checkbox-container'>
                  <Checkbox
                     onChange={(e) => {
                        if (e.target.checked) formik.setFieldValue('personalization', true);
                        else formik.setFieldValue('personalization', undefined);
                     }}
                     checked={formik.values.personalization === true}
                  >
                     ยินยอม
                  </Checkbox>
                  <Checkbox
                     onChange={(e) => {
                        if (e.target.checked) formik.setFieldValue('personalization', false);
                        else formik.setFieldValue('personalization', undefined);
                     }}
                     checked={formik.values.personalization === false}
                  >
                     ไม่ยินยอม
                  </Checkbox>
               </div>
               {formik.touched.personalization && formik.errors.personalization ? (
                  <p className='error'>{formik.errors.personalization}</p>
               ) : null}
            </div>
            <div className='content-box'>
               <div>
                  <h3>ความยินยอมในการพัฒนาการให้บริการ</h3>
                  <p>
                     เพื่อปรับปรุงคุณภาพการบริการ เช่น การวิเคราะห์ข้อมูลการใช้งาน การทำวิจัย หรือการจัดทำสถิติ
                     เพื่อให้บริการดีขึ้น
                  </p>
               </div>
               <div className='checkbox-container'>
                  <Checkbox
                     onChange={(e) => {
                        if (e.target.checked) formik.setFieldValue('improvement', true);
                        else formik.setFieldValue('improvement', undefined);
                     }}
                     checked={formik.values.improvement === true}
                  >
                     ยินยอม
                  </Checkbox>
                  <Checkbox
                     onChange={(e) => {
                        if (e.target.checked) formik.setFieldValue('improvement', false);
                        else formik.setFieldValue('improvement', undefined);
                     }}
                     checked={formik.values.improvement === false}
                  >
                     ไม่ยินยอม
                  </Checkbox>
               </div>
               {formik.touched.improvement && formik.errors.improvement ? (
                  <p className='error'>{formik.errors.improvement}</p>
               ) : null}
            </div>
            <div className='footer-section'>
               <Checkbox
                  checked={formik.values.personalization === true && formik.values.improvement === true}
                  onChange={(e) => {
                     if (e.target.checked) {
                        formik.setFieldValue('personalization', true);
                        formik.setFieldValue('improvement', true);
                     } else {
                        formik.setFieldValue('personalization', undefined);
                        formik.setFieldValue('improvement', undefined);
                     }
                  }}
               >
                  ยินยอมทั้งหมด
               </Checkbox>
               <Button type='primary' size='large' htmlType='submit' loading={loading}>
                  {loading ? 'กำลังดำเนินการ...' : 'ตกลง'}
               </Button>
            </div>
         </form>
      </Modal>
   );
};

export default DataPrivacyModal;
